import { render, staticRenderFns } from "./AbgegebenePackungenEntwicklungView.vue?vue&type=template&id=ec0f7b96&"
import script from "./AbgegebenePackungenEntwicklungView.vue?vue&type=script&lang=js&"
export * from "./AbgegebenePackungenEntwicklungView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports